import { defineMessages } from 'react-intl';

export const articleMessages = defineMessages({
  subtitle: {
    defaultMessage: 'Vision',
    description: 'Featured articles section subtitle',
    id: 'articles.subtitle',
  },
  title: {
    defaultMessage: 'You may also like',
    description: 'Featured articles section title',
    id: 'articles.title',
  },
});
